
export interface EnvConfig {
  baseUrl: string;
  azureAppId: string;
  azureTenantId: string;
  azureRedirectUri: string;
  lokiUrl: string;
  environment: string;
  queryRetry: number;
  queryStaleTimeDefault: number;
  queryStaleTimeShort: number;
}

const getEnvVar = (name: string, defaultValue?: string): string => {
  console.log(process.env)
  const value = process.env[name] || defaultValue;
  if (value === undefined) {
    throw new Error(`Variável de ambiente obrigatória em falta: ${name}`);
  }
  return value;
};

const getEnvNum = (name: string, defaultValue: number): number => {
  const value = process.env[name];
  return value ? Number(value) : defaultValue;
};

export const envConfig: EnvConfig = {
  baseUrl: getEnvVar("REACT_APP_BASE_URL"),
  azureAppId: getEnvVar("REACT_APP_AZURE_APP_ID"),
  azureTenantId: getEnvVar("REACT_APP_AZURE_TENANT_ID"),
  azureRedirectUri: getEnvVar("REACT_APP_AZURE_REDIRECT_URI"),
  lokiUrl: getEnvVar("REACT_APP_LOKI_URL", "http://109.123.248.67:3101"),
  environment: getEnvVar("REACT_APP_ENVIRONMENT", "prod"),
  queryRetry: getEnvNum("REACT_APP_QUERY_RETRY", 5),
  queryStaleTimeDefault: getEnvNum("REACT_APP_QUERY_STALE_TIME_DEFAULT", 0),
  queryStaleTimeShort: getEnvNum("REACT_APP_QUERY_STALE_TIME_SHORT", 0),
};

export const validateEnv = () => {
  try {
    // Apenas aceder ao objeto envConfig já dispara as exceções de getEnvVar
    console.log(`[Config] Ambiente: ${envConfig.environment}`);
    console.log(`[Config] API URL: ${envConfig.baseUrl}`);
  } catch (error: any) {
    console.error("Erro crítico na configuração da aplicação:");
    console.error(error.message);
    
    // Em ambiente de browser, podemos mostrar um alerta ou renderizar um erro fatal
    if (typeof window !== "undefined") {
      document.body.innerHTML = `
        <div style="padding: 20px; color: white; background: red; font-family: sans-serif;">
          <h1>Erro de Configuração</h1>
          <p>${error.message}</p>
          <p>Por favor, verifique o ficheiro .env ou as variáveis de ambiente do servidor.</p>
        </div>
      `;
    }
    throw error;
  }
};
